import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'
import { Response } from '../../../services/api/types'

const loadOrder = (id?: string): Response<any> => {
  return axios.get(`/orders/${id}`)
}

export function useLoadOrder(id?: string) {
  return useQuery(['orders', id], () => loadOrder(id), {
    enabled: !!id,
    select: (data) => ({
      ...data.data,
      saleChannel: data.data.sellerChannel,
      paymentResponsible: data.data.paymentResposible
    }),
    onError: () =>
      toast.error('Não foi possível carregar o pedido', {
        toastId: 'order'
      })
  })
}
